import React, {useState} from "react"
import {Link} from 'gatsby';

import {locales, getCurrentLocale} from "../../utils/getCurrentLocale";
import IconSearch from "./IconSearch";

import searchStyles from './Search.module.scss'


function Search(props) {

    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);

    const locale = getCurrentLocale(props.location.pathname);

    const getSearchResults = query => {
        if (!query || !window.__LUNR__)
            return [];
        const lunrIndex = window.__LUNR__[locale];
        const results_ = lunrIndex.index.search(query);
        return results_.map(({ref}) => lunrIndex.store[ref]);
    };

    const search = event => {
        const query_ = event.target.value;
        const results_ = getSearchResults(query_);
        setResults(results_);
        setQuery(query_);
    };

    return (
        <div>
            <div className = {searchStyles.searchContainer}>
                <input
                    className = {searchStyles.searchInput}
                    type = "text"
                    value = {query}
                    placeholder = {locales[locale].common.search}
                    onChange = {search}
                />
                <button className = {searchStyles.searchButton}>
                    <IconSearch className = {searchStyles.searchIcon}/>
                </button>
            </div>
            <ul className = {searchStyles.searchResultsList}>
                {results.map(page => (
                    <li className = {searchStyles.searchResult} key = {page.id}>
                        <Link className = {searchStyles.searchResultA} to = {"/" + page.slug}>
                            {page.title}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default Search;
